export const formatEmail = (value: string): string =>
  value.trim().replace(/\s+/g, "").toLowerCase();
